<footer class="site-footer">
  <div class="footer-inner">

    <!-- TOP GRID -->
    <div class="footer-grid">

      <!-- COL 1: Logo + Description + Motto -->
      <div class="footer-brand">
        <a href="https://nexgencoaches.com/" aria-label="NexGen Home" class="footer-logo-link">
          <img src="assets/NEXGEN Logo final for footer.png" alt="NexGen Logo" class="footer-logo-img" />
        </a>
        <p class="footer-tagline">
          Preparing accomplished professionals to become credentialed executive coaches and build serious coaching
          businesses. In partnership with Lyssa deHart Coaching.
        </p>
        <div class="footer-motto">Be a Coach. Build a Business.</div>
      </div>

      <!-- COL 2: Programs -->
      <div class="footer-col">
        <h5 class="footer-col-heading">Programs</h5>
        <ul>
          <li><a href="https://nexgencoaches.com/programs/">Silver – Certificate</a></li>
          <li><a href="https://nexgencoaches.com/programs/">Gold ACC</a></li>
          <li><a href="https://nexgencoaches.com/programs/">Platinum PCC</a></li>
        </ul>
      </div>

      <!-- COL 3: Academy -->
      <div class="footer-col">
        <h5 class="footer-col-heading">Academy</h5>
        <ul>
          <li><a href="https://nexgencoaches.com/about-us/">About NEXGEN</a></li>
          <li><a href="https://academy.nexgencoaches.com/community">Community</a></li>
          <li><a href="https://nexgencoaches.com/programs/">Coach Training</a></li>
          <li><a href="https://nexgencoaches.com/terms-and-conditions/">Terms & Conditions</a></li>
          <li><a href="https://nexgencoaches.com/privacy-policy/">Privacy Policy</a></li>
        </ul>
      </div>

      <!-- COL 4: Connect -->
      <div class="footer-col">
        <h5 class="footer-col-heading">Connect</h5>
        <ul>
          <li><a href="https://academy.nexgencoaches.com/live-session/">Free Webinar</a></li>
          <li><a href="https://nexgencoaches.com/contact-us/">Contact Us</a></li>
          <li><a href="https://www.youtube.com/@LyssadeHart" target="_blank" rel="noopener noreferrer">Youtube</a></li>
          <li><a href="https://www.linkedin.com/company/nexgen-executive-coaching-academy/" target="_blank"
              rel="noopener noreferrer">Linkedin</a></li>
          <li><a href="tel:+12482708373">+1 (248) 270-8373</a></li>
        </ul>
      </div>

    </div>

    <!-- DIVIDER -->
    <div class="footer-divider"></div>

    <!-- BOTTOM BAR -->
    <div class="footer-bottom">
      <span class="footer-copy">© {{ currentYear }} NEXGEN Executive Coaching Academy. All rights reserved.</span>
      <span class="icf-badge">ICF ALIGNED</span>
    </div>

  </div>
</footer>